
import { Hotkey } from '@ngneat/hotkeys';
export const HOTKEYS_AVOID_HIDE_CONTROLS = ['s', 'c', 'd', 'r'];

export declare type VgHotkey = Hotkey & {
	handler?: any
};
